'use client'

import textActionM from '@fukku/styles/texts/textActionM.module.css'
import textHeadingM from '@fukku/styles/texts/textHeadingM.module.css'
import { cx } from 'classix'
import type { ReactNode } from 'react'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import styles from './FamilyBannerShopText.module.css'

interface FamilyBannerShopTextProps {
	readonly titleText: string
	readonly ctaText?: string
}

export function FamilyBannerShopText({
	titleText,
	ctaText,
}: FamilyBannerShopTextProps): ReactNode {
	const { isLargeOrGreater } = useResponsive()

	return (
		<div className={styles.textWrapper}>
			<h2 className={cx(styles.title, textHeadingM.className)}>{titleText}</h2>
			{isLargeOrGreater && ctaText && (
				<span className={cx(styles.cta, textActionM.className)}>{ctaText}</span>
			)}
		</div>
	)
}
